// extracted by mini-css-extract-plugin
module.exports = {"heading":"ClientPlatformSwitcher_heading__3GGCu","select":"ClientPlatformSwitcher_select__A1_WP"};